/* global L, windowWidth, breakpointMd, removeActiveClass, MAP_MAX_ZOOM, addOsmLayer */

const MAP_MODAL_PIN_SIZE = 20;
const MAP_MODAL_PIN_ANCHOR = MAP_MODAL_PIN_SIZE / 2;

const createMapModalMarkerIcon = (iconUrl) => {
  const wrapper = document.createElement('div');
  wrapper.className = 'location-marker map-modal-marker__inner';

  if (iconUrl) {
    const img = document.createElement('img');
    img.src = iconUrl;
    img.alt = '';
    wrapper.appendChild(img);
  }

  const icon = L.divIcon({
    className: 'map-modal-marker',
    html: wrapper,
    iconSize: [MAP_MODAL_PIN_SIZE, MAP_MODAL_PIN_SIZE],
    iconAnchor: [MAP_MODAL_PIN_ANCHOR, MAP_MODAL_PIN_ANCHOR],
  });

  return { icon, wrapper };
};

const initMapModal = (modal, mapElement, storeCards, markers) => {
  if (mapElement.dataset.mapInitialized === 'true' || typeof L === 'undefined') return;

  mapElement.dataset.mapInitialized = 'true';

  const pins = modal.querySelectorAll('.map-modal__pin');
  const activeClass = 'location-marker--active';
  const defaultZoom = Number(mapElement.dataset.zoom);

  const map = L.map(mapElement, {
    zoomControl: false,
    attributionControl: true,
    zoomSnap: 1,
    zoomDelta: 1,
    maxZoom: MAP_MAX_ZOOM,
  }).setView([Number(mapElement.dataset.lat), Number(mapElement.dataset.lng)], defaultZoom);

  addOsmLayer(map, { className: 'map-modal-tiles' });

  const clearMarkerActiveState = () => {
    markers.forEach((marker) => marker.setActive(false));
  };

  const focusMapOnMarker = (latLng) => {
    if (windowWidth() < breakpointMd) return;

    const markerLatLng =
      latLng?.lat != null ? L.latLng(latLng.lat, latLng.lng) : L.latLng(Number(latLng[0]), Number(latLng[1]));

    let targetZoom = map.getZoom();
    if (targetZoom <= defaultZoom) {
      targetZoom = Math.min(defaultZoom + 1, MAP_MAX_ZOOM);
    }

    // Map fills `.map-modal__right` only (grid column), not under the list — no pan offset.
    map.flyTo(markerLatLng, targetZoom);
  };

  pins.forEach((pin, index) => {
    const lat = Number(pin.dataset.markerLat);
    const lng = Number(pin.dataset.markerLng);
    const iconUrl = pin.dataset.marker || null;
    const { icon: markerIcon, wrapper: markerWrapper } = createMapModalMarkerIcon(iconUrl);

    const handleMarkerClick = () => {
      const isMobile = windowWidth() < breakpointMd;

      removeActiveClass(storeCards);
      clearMarkerActiveState();

      if (storeCards[index]) {
        storeCards[index].classList.add('is-active');

        modal.classList.add('is-open');

        const activeCard = storeCards[index];
        const scrollContainer = modal.querySelector('.map-modal__left-body');

        if (activeCard && scrollContainer) {
          scrollContainer.scrollTo({
            top: activeCard.offsetTop - 20,
            behavior: 'smooth',
          });
        }
      }

      markers[index]?.setActive(true);

      if (!isMobile) {
        focusMapOnMarker([lat, lng]);
      }
    };

    const leafletMarker = L.marker([lat, lng], { icon: markerIcon }).addTo(map);

    markers[index] = {
      leafletMarker,
      map,
      setActive(active) {
        markerWrapper.classList.toggle(activeClass, active);
      },
      setVisible(visible) {
        if (visible) {
          leafletMarker.addTo(map);
        } else {
          leafletMarker.remove();
        }
      },
    };

    leafletMarker.on('click', (event) => {
      L.DomEvent.stopPropagation(event);
      handleMarkerClick();
    });
  });
};

const modals = document.querySelectorAll('.map-modal');

modals.forEach((modal) => {
  const storeCards = modal.querySelectorAll('.store-card');
  const searchForm = modal.querySelector('.mod-search form');
  const searchInput = modal.querySelector('.mod-search .mod-input__field');
  const notFound = modal.querySelector('[data-not-found]');
  const markers = [];

  const filterStores = (term) => {
    const query = term.trim().toLowerCase();
    let visibleCount = 0;

    storeCards.forEach((card, index) => {
      const text = card.textContent.toLowerCase();
      const isMatch = !query || text.includes(query);

      card.classList.toggle('hide', !isMatch);
      markers[index]?.setVisible(isMatch);

      if (isMatch) visibleCount += 1;
    });

    notFound?.classList.toggle('hide', visibleCount > 0);
  };

  if (searchInput) {
    searchInput.addEventListener('input', (ev) => filterStores(ev.target.value));
  }

  searchForm?.addEventListener('submit', (ev) => ev.preventDefault());

  const mapElement = modal.querySelector('#map-modal__init');

  if (!mapElement || mapElement.dataset.mapInitialized === 'true') return;

  if (typeof L === 'undefined') {
    window.addEventListener(
      'load',
      () => {
        if (typeof L !== 'undefined' && mapElement.dataset.mapInitialized !== 'true') {
          initMapModal(modal, mapElement, storeCards, markers);
        }
      },
      { once: true },
    );
    return;
  }

  initMapModal(modal, mapElement, storeCards, markers);
});

// Toggle mobile location list
const toggleModalOpenClass = (parent, toggle) => {
  const currentModal = parent.closest('.map-modal');
  currentModal?.classList.toggle('is-open', toggle);
};

attachEvent('.map-modal__button', 'click', (ev) => {
  toggleModalOpenClass(ev.target, true);
});

attachEvent('.map-modal__left-close', 'click', (ev) => {
  toggleModalOpenClass(ev.target, false);
});
